module.exports = __webpack_public_path__ + "img/HEAT.4d3321ac.svg";